import { render, staticRenderFns } from "./feedback2.vue?vue&type=template&id=beccf632&scoped=true"
import script from "./feedback2.vue?vue&type=script&lang=js"
export * from "./feedback2.vue?vue&type=script&lang=js"
import style0 from "./feedback2.vue?vue&type=style&index=0&id=beccf632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beccf632",
  null
  
)

export default component.exports